import { AuthResponseCode } from '@dwelvio/auth-react';
import { Box, Button, FormControl, FormLabel, Input, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

interface SignInFormProps {
  username?: string;
  onSignin: (username: string, password: string) => Promise<AuthResponseCode>;
  onSuccess: () => void;
}

interface SignInFormValues {
  username: string;
  password: string;
}

export function SignInForm(props: SignInFormProps) {
  const [serverError, setServerError] = useState<string | null>(null);
  const { register, handleSubmit } = useForm<SignInFormValues>({
    defaultValues: { username: props.username || '', password: '' },
  });

  const onSubmit = async (data: SignInFormValues) => {
    setServerError(null);
    const r = await props.onSignin(data.username, data.password);

    if (r === 'success') {
      props.onSuccess();
    } else {
      if (r === 'email_not_verified') {
        setServerError('Váš email ešte nebol overený. Skontrolujte svoju emailovú schránku.');
      } else {
        setServerError('Neplatné prihlasovacie údaje');
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2} sx={{ mb: 2 }}>
        <FormControl required fullWidth>
          <FormLabel>E-mail</FormLabel>
          <Input autoComplete="username" {...register('username')} />
        </FormControl>

        <FormControl required>
          <FormLabel>Heslo</FormLabel>
          <Input type="password" autoComplete="current-password" {...register('password')} />
        </FormControl>
      </Stack>
      <Button fullWidth variant="contained" type="submit">
        Prihlásiť sa
      </Button>
      {serverError && (
        <Box sx={{ mt: 2 }} display="flex" justifyContent="center">
          <Typography variant="body2" color="error">
            {serverError}
          </Typography>
        </Box>
      )}
    </form>
  );
}
